// extracted by mini-css-extract-plugin
export default {"tableTitle":"tableTitle__+VUOQ","recTable":"recTable__JQaVb","head":"head__lIzgy","mid":"mid__GkA8D","last":"last__82ZY3"};